"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const global_1 = require("../../../commons/global");
const Constants_1 = require("../../../commons/Constants");
const entity_helper_v2_service_1 = require("./entity-helper-v2.service");
const map_service_1 = require("../../../commons/map.service");
const FeatureCollection_1 = require("../../../main/map/detail-views/annots/FeatureCollection");
const Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class GeomAnnotationRenderer extends _4d_mapper_1.Renderer {
    constructor(viewer) {
        super();
        this.viewer = viewer;
        this.debug = Constants_1.Constants.debug_off;
        // stylished debug info
        this.debugStyle = 'color:red;background-color:#ccc;';
        // reusable temporary catrographic object
        this.tempCartographic = new Cesium.Cartographic();
        this.number_precission = 2;
        this.entityHelper = new entity_helper_v2_service_1.EntityHelperServiceV2(viewer);
        this._log();
    }
    // The renderer methods
    onAdd(obj, args) {
        this._log('onAdd', [obj, args]);
        // TODO alex split smarts to draw, and update
        return rxjs_1.of({
            plottable: obj,
            object: {}
        });
    }
    onUpdate(obj, pr, args) {
        this.deleteAnnotationShapes(obj);
        return this.createAnnotationShapes(obj).map(res => {
            return {
                plottable: obj,
                object: res
            };
        });
    }
    onRemove(obj, pr) {
        this.deleteAnnotationShapes(obj);
    }
    destory() {
        throw new Error("Method not implemented.");
    }
    // Alexes meausrement-helper.service
    createAnnotationShapes(a) {
        let type = a['annotationMode'];
        const debugStyle = 'color:white;background-color:orange;';
        // console.log ( '%c createAnnotationShapes "'+a.name+'" ['+a.id+']', debugStyle, a );
        if (a['shapes']) {
            // for each shape
            a['shapes'].forEach(function (current_shape, idx) {
                // shape has 2 or more points?
                if (current_shape.points && current_shape.points.length > 1) {
                    this.createAnnotationShape(a, idx, current_shape);
                }
                else {
                    console.error('MeasureHelper :: CreateAnnotationShapes = [' + type + '] wanted, but not enough points', a);
                }
            }, this); // remember 'this' to avoid this spaghetti
        }
        return rxjs_1.of(null);
    }
    createAnnotationShape(a, idx, current_shape) {
        let type = a['annotationMode'];
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        // line/shape properties
        let props = {
            shapeRef: idx,
            annotationRef: annotationRef,
            positions: [],
            lineWidth: current_shape['lineWidth'],
            color: Cesium.Color.fromCssColorString(current_shape['color']),
            colorAlpha: 1,
            perPositionHeight: !current_shape['clamping'],
            clampToGround: current_shape['clamping']
        };
        if (current_shape['points'] && current_shape['points'] instanceof Array && current_shape['points'].length > 0) {
            props['positions'] = current_shape['points'].map(p => { if (p && p.coords)
                return p.coords; });
        }
        let _obj = this.entityHelper.addEntity(type, props, a, 'measure-helper-' + annotationRef);
        if (_obj) {
            // if ( this.debug ) { 
            // console.log ( '%c createAnnotationShape CREATED', this.debugStyle, idx, a['shapes'], current_shape, props, _obj); 
            if (a['shapes'][idx])
                a['shapes'][idx]['entityRef'] = _obj;
            current_shape.entityRef = _obj;
            return _obj;
        }
        if (this.debug) {
            console.log('%c createAnnotationShape FAILED', this.debugStyle, current_shape, props, _obj);
        }
        if (a['shapes'][idx])
            a['shapes'][idx]['entityRef'] = null;
        current_shape.entityRef = null;
        return null;
    }
    deleteAnnotationShapes(a) {
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        let type = a['annotationMode'];
        let _deleted = [];
        this.entityHelper.destroyEntitiesByCaller('measure-helper-' + annotationRef);
        if (this.debug) {
            console.log('%c deleteAnnotationShapes', this.debugStyle, type, _deleted, a);
        }
    }
    // convert old format (found in Annotation['points']) to the new
    convertFromOldFormat(a) {
        // our final shape object
        let shapes = [];
        // type of annotation
        let type = a['annotationMode'];
        const debugStyle = 'color:white;background-color:green;';
        // Pin?
        if (type === global_1.AnnotationType.poi) {
            // No shape support (we use addPlottable() for these for now)
            // All else?
        }
        else {
            // Has it got shapes? [Note: 'points' is a misnomer, and need some refactoring/renaming in the future]
            if (a['points']) {
                // for each shape
                for (let shape = 0; shape < a['points'].length; shape++) {
                    let current_shape = {
                        annotationRef: a.id,
                        oldPositionRef: shape
                    };
                    let shapes_with_points = [];
                    // Go through all points (if exists)
                    a['points'][shape].forEach(point => {
                        // index of entities for this shape
                        if (point && point['coords']) {
                            shapes_with_points.push(true);
                        }
                        else {
                            // console.log ( ' - no conversion of NULL point', a.id, a['points'][shape], shape, point );
                        }
                    });
                    // any points in the shape? Then add it to our index
                    if (shapes_with_points.length > 1) {
                        // defaults
                        if (!current_shape['color']) {
                            current_shape['color'] = this.getOldFormatShapeProperty('currentColor', shape, a, '#0ff000');
                        }
                        if (!current_shape['lineColor']) {
                            current_shape['lineColor'] = this.getOldFormatShapeProperty('currentColor', shape, a, '#00ff00');
                        }
                        if (!current_shape['lineWidth']) {
                            current_shape['lineWidth'] = 5;
                        }
                        if (!current_shape['clamping']) {
                            current_shape['clamping'] = this.getOldFormatShapeProperty('clampToModel', shape, a, false);
                        }
                        if (!current_shape['shapeInfo']) {
                            current_shape['shapeInfo'] = this.getOldFormatShapeProperty('showLineInfo', shape, a, true);
                        }
                        // default/first shape should open their options by default
                        if (shape == 0) {
                            current_shape['showOptions'] = true;
                        }
                        // transfer in the points
                        current_shape['points'] = a['points'][shape];
                        shapes.push(current_shape);
                    }
                }
            }
        }
        if (this.debug) {
            console.log('%c convertFromOldFormat "' + a.name + '" [' + a.id + ']', debugStyle, a, shapes);
        }
        return shapes;
    }
    getOldFormatShapeProperty(p, shape, a, _default) {
        let s = a['pointsProps'][shape];
        let find = s.findIndex(e => e[p]);
        let test = find !== -1 ? s[find][p] : false;
        return test ? test : _default;
    }
    // quick validator for the Shapes object
    testFormat(shapes) {
        let valid = true;
        for (let n = 0; n < shapes.length; n++) {
            if (shapes[n]) {
                let shape = shapes[n];
                // console.log ( 'testingFormat() shape', shape);
                for (let p = 0; p < shape.points.length; p++) {
                    let point = shape.points[p];
                    // console.log ( 'testingFormat() point', point);
                    if (!point || !point['coords']) {
                        valid = false;
                    }
                    else {
                        if (!point['coords'] || !point.coords['x'] || !point.coords['y'] || !point.coords['z']) {
                            valid = false;
                        }
                    }
                }
            }
            else {
                valid = false;
            }
        }
        return valid;
    }
    // we need to convert all Cartesian3 coordinates to standard objects before saving
    prepareForSerialising(shapes) {
        // console.log ( 'prepFormat()', shapes );
        for (let n = 0; n < shapes.length; n++) {
            if (shapes[n]) {
                let shape = shapes[n];
                for (let p = 0; p < shape.points.length; p++) {
                    let point = shape.points[p];
                    if (point && point['coords']) {
                        let coords = point['coords'];
                        if (coords.constructor.name == 'Cartesian3') {
                            shapes[n].points[p].coords = { x: coords.x, y: coords.y, z: coords.z };
                        }
                    }
                }
            }
        }
        // console.log ( 'prepFormat() DONE', shapes );
        return shapes;
    }
    /*
         Handy calculators for measuring stuff, mostly point-to-point
    */
    realNumber(x) {
        return Number.parseFloat(x).toFixed(this.number_precission);
    }
    getLocalisedValue(value, a = null) {
        if (a && a.project && a.project['number_precission']) {
            this.number_precission = a.project['number_precission'];
        }
        const feetValue = 0.3048;
        var units = map_service_1.MapService.METER;
        var sign = 'm';
        if (a && a.project && a.project['measurementUnit']) {
            units = a.project['measurementUnit'];
        }
        if (units === map_service_1.MapService.FEET) {
            sign = 'ft';
            value = value / feetValue;
        }
        if (isNaN(value)) {
            return '0' + sign;
        }
        // console.log ( '%c XXXXXX', value, sign, units );
        return this.realNumber(value) + sign;
    }
    calculateLineInformation(here, there) {
        let ret = this.calculateSlope(here, there);
        ret['length'] = this.calculateLength(here, there);
        ret['midpoint'] = this.calculateMidpoint(here, there);
        ret['azimuth'] = this.calculateAzimuth(here, there);
        return ret;
    }
    // calculate the length between two points
    calculateMidpoint(here, there) {
        var scratch = new Cesium.Cartesian3();
        var difference = Cesium.Cartesian3.subtract(here, there, scratch);
        var distance = Cesium.Cartesian3.magnitude(difference);
        var direction = Cesium.Cartesian3.normalize(difference, scratch);
        return Cesium.Cartesian3.add(there, Cesium.Cartesian3.multiplyByScalar(direction, distance * 0.5, scratch), scratch);
    }
    // calculate the length between two points
    calculateLength(here, there) {
        let distance = Cesium.Cartesian3.distance(here, there);
        return distance;
    }
    // calculate slope between two points
    calculateSlope(start, end) {
        'use strict';
        var ellipsoid = Cesium.Ellipsoid.WGS84;
        var geoStartAndEnd = ellipsoid.cartesianArrayToCartographicArray([start, end]);
        var geoStart = geoStartAndEnd[0], geoEnd = geoStartAndEnd[1];
        // If the height of the start point is larger than the endpoint then the sign of the elevation change is negative
        // This also causes the slope degrees to be negative
        var slopesDown = geoStart.height > geoEnd.height;
        // Set the height of geoEnd to be the same as geoStart, and convert back to cartesian
        geoEnd.height = geoStart.height;
        var normalisedEnd = ellipsoid.cartographicToCartesian(geoEnd);
        // Store the vector parallel to surface in this
        var parallel = { x: '', y: '', z: '' };
        Cesium.Cartesian3.subtract(normalisedEnd, start, parallel);
        var normal = { x: '', y: '', z: '' };
        Cesium.Cartesian3.subtract(end, normalisedEnd, normal);
        // The result, start to end, is composed of a run of length <startToEndOnEarthSurface>
        // and a rise of <projectedToEndFromEarthSurface>, so compute those
        var parallelDistance = Math.sqrt(Math.pow(parallel.x, 2) + Math.pow(parallel.y, 2) + Math.pow(parallel.z, 2));
        var normalDistance = Math.sqrt(Math.pow(normal.x, 2) + Math.pow(normal.y, 2) + Math.pow(normal.z, 2));
        if (slopesDown) {
            normalDistance *= -1;
        }
        return {
            lengthHorizontal: Math.abs(parallelDistance),
            slopeVertical: Math.abs(normalDistance),
            slopePercent: Math.abs(normalDistance / parallelDistance * 100)
        };
    }
    calculateAzimuth(cartesianPointA, cartesianPointB) {
        'use strict';
        var cartographicPointA = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesianPointA), cartographicPointB = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesianPointB);
        var longA = cartographicPointA.longitude, longB = cartographicPointB.longitude, latA = cartographicPointA.latitude, latB = cartographicPointB.latitude;
        var longChange = Math.sin(longB - longA) * Math.cos(latB);
        var latChange = Math.cos(latA) * Math.sin(latB) - Math.sin(latA) * Math.cos(latB) * Math.cos(longB - longA);
        var bearingDegrees = (Math.atan2(longChange, latChange) * (180 / Math.PI));
        return (bearingDegrees + 360) % 360;
    }
    calculateCentroid(pts) {
        var first = pts[0], last = pts[pts.length - 1];
        if (first.x != last.x || first.y != last.y)
            pts.push(first);
        var twicearea = 0, x = 0, y = 0, z = 0, nPts = pts.length, p1, p2, f;
        for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
            p1 = pts[i];
            p2 = pts[j];
            f = (p1.y - first.y) * (p2.x - first.x) - (p2.y - first.y) * (p1.x - first.x);
            twicearea += f;
            x += (p1.x + p2.x - 2 * first.x) * f;
            y += (p1.y + p2.y - 2 * first.y) * f;
            if (p1.z > z) {
                z = p1.z;
            }
        }
        f = twicearea * 3;
        return { x: x / f + first.x, y: y / f + first.y, z: z };
    }
    // END of refactoring; all the following code is older, and may or may not still be in use (future project to purge ...)
    getGeoJSON(annotation) {
        const debugStyle = 'color:red;background-color:#ccc;';
        /*
        if ( ! annotation['points'] ) {
          console.log ( '%c getGeoJSON: No points (probably empty or a Pin)', debugStyle, annotation);
          return;
        }
        */
        let a_name = annotation.name;
        let a_id = annotation.id;
        let featureCollection = new FeatureCollection_1.FeatureCollection();
        featureCollection.type = 'FeatureCollection';
        featureCollection.features = [];
        if (annotation['shapes']) {
            // single pins
            if (annotation['annotationMode'] === 'poi') {
                let geometry = new FeatureCollection_1.Geometry();
                geometry.type = 'Point';
                geometry.coordinates = [];
                let coords = [annotation.llng, annotation.llat, annotation.lheight];
                // console.log ( '   coords (pin)', coords);
                geometry.coordinates = coords;
                let features = new FeatureCollection_1.Features();
                features.type = 'Feature';
                features.geometry = geometry;
                features.properties = {
                    name: a_name + ' [Pin]',
                    id: a_id
                };
                featureCollection.features.push(features);
            }
            // multi-points
            else if (annotation['annotationMode'] === 'multiPoi') {
                for (let i = 0; i < annotation['shapes'].length; i++) {
                    let shape = annotation['shapes'][i];
                    shape.points.forEach(v1 => {
                        let geometry = new FeatureCollection_1.Geometry();
                        geometry.type = 'Point';
                        geometry.coordinates = [];
                        // console.log ( '   coords (multi-pin)', v1['coords']);
                        let latLong = Cesium.Cartographic.fromCartesian(v1['coords'], Cesium.Ellipsoid.WGS84, this.tempCartographic);
                        geometry.coordinates = [latLong.longitude * 180 / Math.PI, latLong.latitude * 180 / Math.PI, latLong.height];
                        let features = new FeatureCollection_1.Features();
                        features.type = 'Feature';
                        features.geometry = geometry;
                        features.properties = {
                            name: a_name + ' (' + i + ') [MultiPoint]',
                            id: a_id + '_' + i,
                            'clampToModel': shape['clampToModel'] ? shape['clampToModel'] : null,
                            'color': shape['color'] ? shape['color'] : null,
                            'lineWidth': shape['lineWidth'] ? shape['lineWidth'] : null,
                        };
                        // if (annotation['pointsProps'][i].findIndex(e => e['currentColor']) !== -1) {
                        //   features.properties['currentColor'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentColor'])]['currentColor']
                        // }
                        featureCollection.features.push(features);
                    });
                }
                // all other shapes
            }
            else {
                // for each shape
                for (let i = 0; i < annotation['shapes'].length; i++) {
                    let shape = annotation['shapes'][i];
                    let geometry = new FeatureCollection_1.Geometry();
                    geometry.type = (annotation['annotationMode'] === 'line' || annotation['annotationMode'] === 'flyToLine') ? 'LineString' : 'Polygon';
                    geometry.coordinates = [];
                    let arr = [];
                    // lines must be longer than 1 point, and all other (polygons) must be longer than 2
                    if (annotation['annotationMode'] === 'line' && shape.points.length < 2)
                        return;
                    else if (annotation['annotationMode'] !== 'line' && shape.points.length < 3)
                        return;
                    // console.log ( '@@@@@@@@@@@@@@@@@', i, annotation['shapes'][i] );
                    shape.points.forEach(v1 => {
                        // console.log ( '   coords (shape)', v1['coords']);
                        let latLong = Cesium.Cartographic.fromCartesian(v1['coords'], Cesium.Ellipsoid.WGS84, this.tempCartographic);
                        arr.push([latLong.longitude * 180 / Math.PI, latLong.latitude * 180 / Math.PI, latLong.height]);
                    });
                    if (arr.length > 0) {
                        if (annotation['annotationMode'] === 'line') {
                            geometry.coordinates = arr;
                        }
                        else {
                            geometry.coordinates.push(arr);
                        }
                        let features = new FeatureCollection_1.Features();
                        features.type = 'Feature';
                        features.geometry = geometry;
                        features.properties = {
                            name: a_name + ' (' + i + ') [' + annotation['annotationMode'] + ']',
                            id: a_id + '_' + i,
                            'clampToModel': shape['clampToModel'] ? shape['clampToModel'] : null,
                            'color': shape['color'] ? shape['color'] : null,
                            'lineWidth': shape['lineWidth'] ? shape['lineWidth'] : null,
                            'calculations': shape['calc'] ? shape['calc'] : null,
                        };
                        /*
                        if (annotation['pointsProps'][i].findIndex(e => e['measuredValue']) !== -1) {
                          if (annotation['annotationMode'] === 'area') {
                            features.properties['area'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['measuredValue'])]['measuredValue']
                          } else if (annotation['annotationMode'] === 'volume') {
                            features.properties['volume'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['measuredValue'])]['measuredValue']
                          }
                        }
            
                        if (annotation['pointsProps'][i].findIndex(e => e['currentColor']) !== -1) {
                          features.properties['currentColor'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentColor'])]['currentColor'];
                        }
                        if (annotation['pointsProps'][i].findIndex(e => e['currentLineWidth']) !== -1 ) {
                          features.properties['currentLineWidth'] = annotation['pointsProps'][i][annotation['pointsProps'][i].findIndex(e => e['currentLineWidth'])]['currentLineWidth'];
                        }
                        */
                        featureCollection.features.push(features);
                    }
                }
            }
        }
        return featureCollection;
    }
    sendFile(data, annotation, snackBar, mapComp) {
        let imageName = annotation.name + '.json';
        var xhr = new XMLHttpRequest();
        var upload = xhr.upload;
        upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
                console.log(evt);
            }
        }, false);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (!xhr.responseText || xhr.responseText === '') {
                    snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    return;
                }
                // good response
                var res = JSON.parse(xhr.responseText);
                if (res.status && res.status === 200) {
                    {
                    }
                }
                else if (res.status && res.status < 400) {
                    console.log('vasat error');
                    snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    // vasat error
                }
                else {
                    snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    console.log('all good');
                }
            }
        };
        xhr.open('POST', mapComp.fourD.V.config.host + '/api/Annotation/' + annotation.id + '/' + imageName);
        xhr.overrideMimeType('application/binary');
        xhr.setRequestHeader('Content-Type', 'application/binary');
        xhr.setRequestHeader('Authorization', 'Bearer ' + mapComp.fourD.V.token);
        let d = JSON.stringify(data);
        xhr.send(d);
    }
    // currently skiped this reading, no backward compatibility
    readCoordinatesFromFileAndPrint(annotation) {
        //if annotation is already created and is not poi then only get the json file
        if (annotation.id && annotation['annotationMode'] !== 'poi') {
            fetch(annotation.file(annotation.name + '.json'))
                .then(res => res.text())
                .then(s => {
                let parsedData = JSON.parse(s);
                console.log(parsedData);
                if (parsedData) {
                    let featureCollection = parsedData;
                    annotation['points'] = [];
                    annotation['pointsProps'] = [];
                    if (annotation['annotationMode'] === 'line') {
                        featureCollection.features.forEach(f => {
                            let aa = [];
                            let pp = [];
                            f.geometry.coordinates.forEach(coords => {
                                aa.push({ 'coords': Cesium.Cartesian3.fromDegrees(coords[0], coords[1], coords[2]) });
                            });
                            pp.push({ 'clampToModel': !!f.properties['clampToModel'] });
                            if (f.properties['currentColor']) {
                                pp.push({ 'currentColor': f.properties['currentColor'] });
                            }
                            if (f.properties['currentLineWidth']) {
                                pp.push({ 'currentLineWidth': f.properties['currentLineWidth'] });
                            }
                            annotation['points'].push(aa);
                            annotation['pointsProps'].push(pp);
                        });
                    }
                    else if (annotation['annotationMode'] === 'multiPoi') {
                        let aa = [];
                        let pp = [];
                        featureCollection.features.forEach(f => {
                            aa.push({ 'coords': Cesium.Cartesian3.fromDegrees(f.geometry.coordinates[0], f.geometry.coordinates[1], f.geometry.coordinates[2]) });
                        });
                        pp.push({ 'clampToModel': !!featureCollection.features[0].properties['clampToModel'] });
                        if (featureCollection.features[0].properties['currentColor']) {
                            pp.push({ 'currentColor': featureCollection.features[0].properties['currentColor'] });
                        }
                        if (featureCollection.features[0].properties['currentLineWidth']) {
                            pp.push({ 'currentLineWidth': featureCollection.features[0].properties['currentLineWidth'] });
                        }
                        annotation['points'].push(aa);
                        annotation['pointsProps'].push(pp);
                    }
                    else {
                        featureCollection.features.forEach(f => {
                            f.geometry.coordinates.forEach(coords => {
                                let aa = [];
                                let pp = [];
                                coords.forEach(subCords => {
                                    aa.push({ 'coords': Cesium.Cartesian3.fromDegrees(subCords[0], subCords[1], subCords[2]) });
                                });
                                pp.push({ 'clampToModel': !!f.properties['clampToModel'] });
                                if (f.properties['currentColor']) {
                                    pp.push({ 'currentColor': f.properties['currentColor'] });
                                }
                                if (f.properties['currentLineWidth']) {
                                    pp.push({ 'currentLineWidth': f.properties['currentLineWidth'] });
                                }
                                annotation['points'].push(aa);
                                annotation['pointsProps'].push(pp);
                            });
                        });
                        if (annotation['clipPlanes']) {
                            // TODO turned off
                            //annotation['points'].forEach(point => {
                            // this.mapService.clipPlanes(point, annotation['clipPlanes']);
                            //})
                        }
                    }
                    annotation.saveObservable().subscribe();
                    if (annotation['showPermanent']) {
                        console.log('measure_helper.service :: readCoordinates() -> showPermanentPoints()');
                        // this.showPermanentPoints(annotation, true);
                    }
                }
            }, error1 => {
                console.log(error1);
            });
        }
    }
}
exports.GeomAnnotationRenderer = GeomAnnotationRenderer;
